function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function _object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = _object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
import { jsx as _jsx } from "react/jsx-runtime";
import * as React from "react";
import { cva } from "class-variance-authority";
import { cn } from "../utils";
const badgeVariants = cva("inline-flex items-center rounded-full border px-2.5 py-0.5 text-xs font-normal transition-colors focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2", {
    variants: {
        variant: {
            default: "border-white/20 bg-grayscale-medium text-white/[0.85] hover:border-white/[0.35]",
            secondary: "border-white/20 bg-grayscale-light text-white/[0.85] hover:border-white/[0.35]",
            destructive: "border-transparent bg-alert text-white hover:bg-alert/90",
            outline: "border-white/20 text-white/[0.85]",
            accent: "border-transparent bg-accent text-grayscale-darkest hover:bg-accent/90",
            dark: "border-white/20 bg-grayscale-dark text-white/[0.85] hover:border-white/[0.35]",
            darker: "border-white/20 bg-grayscale-darker text-white/[0.85] hover:border-white/[0.35]"
        }
    },
    defaultVariants: {
        variant: "default"
    }
});
function Badge(_param) {
    var { className, variant } = _param, props = _object_without_properties(_param, [
        "className",
        "variant"
    ]);
    return /*#__PURE__*/ _jsx("div", _object_spread({
        className: cn(badgeVariants({
            variant
        }), className)
    }, props));
}
export { Badge, badgeVariants };
